import { makeStyles, createStyles, MuiTheme, color } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      ticketSelectionContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 24px 24px 24px',
        minWidth: '100%',
        background: 'transparent'
      },
      ticketSelectInnerContainer: {
        background: 'white',
        minWidth: '100%',
        borderRadius: '8px',
        height: '809px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        overflow: 'hidden',
        [theme.breakpoints.down('lg')]: {
          height: '1640px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '755px'
        }
      },
      ticketImageBlock: {
        width: '590px',
        height: '809px',
        overflow: 'hidden',
        background: 'transparent',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        padding: '40px 48px 40px 48px',
        [theme.breakpoints.down('lg')]: {
          width: '100%',
          padding: '0px 0px 40px 0px'
        },
        [theme.breakpoints.only('lg')]: {
          width: '456px'
        }
      },
      ticketImageCard: {
        height: '370px',
        padding: 0,
        alignSelf: 'center',
        [theme.breakpoints.down('lg')]: {
          display: 'flex',
          flex: '1 1 auto',
          justifyContent: 'center',
          maxHeight: '636px',
          width: '784px',
          padding: '48px 0 0',
          borderBottom: `1px solid ${color.LIGHT_GRAY}`
        },
        [theme.breakpoints.only('lg')]: {
          height: '421px',
          padding: '16px'
        }
      },
      ticketDefaultImage: {
        height: '100%',
        objectFit: 'cover',
        [theme.breakpoints.down('lg')]: {
          width: '100%',
          objectFit: 'scale-down'
        }
      },
      ticketImage: {
        maxWidth: '100%',
        height: '100%',
        objectFit: 'cover'
      },
      ticketDateTime: {
        fontSize: '24px',
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal',
        [theme.breakpoints.down('lg')]: {
          paddingLeft: '48px'
        }
      },
      eventDetailsBlock: {
        flexOverride: 'none',
        borderTop: `1px solid ${color.LIGHT_GRAY}`,
        padding: '48px 0 0 0',
        overflow: 'hidden',
        maxHeight: '350px',
        [theme.breakpoints.down('lg')]: {
          borderTop: 'none'
        }
      },
      eventDescription: {
        fontSize: '24px',
        fontWeight: 600,
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal',
        [theme.breakpoints.down('lg')]: {
          padding: '0 48px'
        }
      },
      ticketName: {
        fontWeight: 600,
        fontSize: '32px',
        margin: '0px',
        letterSpacing: 'normal',
        fontFamily: props.fontFamily,
        [theme.breakpoints.down('lg')]: {
          paddingLeft: '48px'
        }
      },
      ticketContentBlock: {
        height: '809px',
        background: 'transparent',
        padding: '32px 56px',
        flex: '1 1 0%',
        [theme.breakpoints.down('lg')]: {
          padding: '32px 24px 24px 24px'
        },
        [theme.breakpoints.only('lg')]: {
          padding: '20px 21px 25px 30px',
          height: '750px'
        },
        '& > *': {
          margin: '0px 0px 0px 0px'
        }
      },
      ticketHeaderBlock: {
        [theme.breakpoints.down('lg')]: {
          paddingLeft: '24px'
        },
        [theme.breakpoints.only('lg')]: {
          paddingLeft: '0px'
        }
      },
      ticketHeader: {
        fontWeight: 800,
        fontSize: '64px',
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal',
        [theme.breakpoints.down('lg')]: {
          fontSize: '48px',
          width: '474px'
        }
      },
      ticketSubHeading: {
        background: 'transparent',
        flex: 'none',
        [theme.breakpoints.down('lg')]: {
          width: '100%'
        },
        [theme.breakpoints.only('lg')]: {
          width: '610px',
          height: '30px'
        }
      },
      footerTextBlock: {
        borderTop: '1px solid #c8c8c8',
        justifyContent: 'flex-start',
        padding: '12px 0px 0px 0px',
        margin: '12px 0px 0px 0px',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          justifyContent: 'center',
          padding: '20px 0px 0px 0px',
          margin: '0px'
        },
        [theme.breakpoints.only('lg')]: {
          justifyContent: 'flex-start',
          padding: '12px 0px 0px 0px',
          margin: '2px 0px 0px 0px'
        }
      }
    })
  );
